import { crashReporter, logger } from './analyticsMiddleWare';
import tracker from './embeddedGATrackcer';
let googleCrashReporter = crashReporter(tracker);
let googleAnalyticsMiddleWare = logger(tracker);

export {googleCrashReporter as crashReporter,googleAnalyticsMiddleWare};
